import {PencilLine, PlusSquare, Trash} from 'lucide-angular';
import { MenuAction } from '@shared/interfaces/header/menu-action';


export const chargeinformationSetupPricesActionMenu: MenuAction[] = [
  {
    id: 'create',
    title: 'action.add',
    icon: PlusSquare
  },
  {
    id: 'edit',
    title: 'action.edit',
    icon: PencilLine,
    disabled: true
  },
  {
    id: 'remove',
    title: 'action.remove',
    icon: Trash,
    iconColor: 'text-red-500',
    disabled: true,
  },
];
